<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="modelValue" class="overlay" @click.self="onBackdrop">
        <div class="modal">
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
// Par DÉFAUT, un clic sur le fond NE FERME PAS le modal : on ne ferme que par
// un bouton explicite (croix / Annuler), pour ne pas perdre par mégarde un
// formulaire en cours en cliquant à côté. Mettre `:dismissable="true"` pour
// rétablir la fermeture au clic extérieur sur un modal non sensible.
const props = withDefaults(defineProps<{ modelValue: boolean; dismissable?: boolean }>(), {
  dismissable: false,
})
const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()

function onBackdrop() {
  if (props.dismissable) emit('update:modelValue', false)
}
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0; z-index: 9000;
  background: rgba(14, 21, 37, 0.58);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
}
.modal {
  background: var(--surface);
  padding: 24px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  min-width: 320px;
  box-shadow: var(--shadow-xl);
  font-family: var(--font);
}

.modal-enter-active, .modal-leave-active { transition: opacity 0.15s; }
.modal-enter-active .modal, .modal-leave-active .modal { transition: transform 0.18s var(--ease-out), opacity 0.15s; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
.modal-enter-from .modal, .modal-leave-to .modal { transform: translateY(10px) scale(0.97); opacity: 0; }
</style>
